/*
 * Params:
 * personId, projectId, recent, page (0 based), size, order
 */
import { abortableFetch, clientFetch } from '../clientFetch';

export const publicationSearchResults = (params) => {
  return abortableFetch('/search/publications', { params }, 'publicationSearch');
};

export const publicationSearch = (params) => {
  return clientFetch('/search/publications', { params });
};
